import { HttpClient } from '@angular/common/http';
// Angular modules.
import { Injectable } from '@angular/core';
// Zenklub interfaces.
import { ICountry, IRegion } from 'app/interfaces/location.interface';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class LocationService {
	servicesUrl = environment.servicesUrl;
	// Constructor method.
	constructor(protected http: HttpClient) {}

	// Get availables countries.
	public getCountries(): Observable<ICountry[]> {
		return this.http.get<ICountry[]>('search/countries');
	}

	// Get regions of a country.
	public getCountryRegions(countryId: ICountry['id']): Observable<IRegion[]> {
		return this.http.get<IRegion[]>(`search/regions?countryId=${countryId}`);
	}

	public getAddressByPostalCode(postalCode: string) {
		return this.http.get<any>(`https://viacep.com.br/ws/${postalCode}/json/`);
	}
}
